import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SpatialDataService {

  private url = `${environment.apiGraphURL}/spatial-data`;

  constructor(private http: HttpClient) {
  }

  getSpatialVariables(): Observable<any> {
    return this.http.get(`${environment.apiURL}/spatial-variables`)
  }

  get(data): Observable<any> {
    return this.http.post(this.url, data);
  }
}
